/* eslint-disable jira/filename-case */
/**
 * The types of entity limits for collections
 */
export const ENTITY_LIMIT_TYPE = {
	VIEWS_PER_COLLECTION: 'viewsPerCollection',
	COLLECTIONS_PER_SITE: 'collectionsPerSite',
	VIEWSETS_PER_COLLECTION: 'viewsetsPerCollection',
} as const;
